import { Organization } from 'services/organization/type';

export const resolveOrganizationDisplayName = (
  organization: Pick<Organization, 'name' | 'candidateDisplayName'>
): string => organization.candidateDisplayName || organization.name;
